export default "__VITE_ASSET__DAvYkUep__"